import React from 'react';
import { Link, useLocation, Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Inbox, Trello, Settings, CheckSquare, FileText, Send, CalendarDays } from 'lucide-react';
import NotificationBell from './NotificationBell';

const Layout = () => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-slate-600">Loading...</div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const navItems = [
        { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
        { path: '/inbox', icon: Inbox, label: 'Inbox' },
        { path: '/pipeline', icon: Trello, label: 'Pipeline' },
        { path: '/tasks', icon: CheckSquare, label: 'Tasks' },
        { path: '/calendar', icon: CalendarDays, label: 'Calendar' },
        { path: '/templates', icon: FileText, label: 'Templates' },
        { path: '/campaigns', icon: Send, label: 'Campaigns' },
        { path: '/settings', icon: Settings, label: 'Settings' }
    ];

    return (
        <div className="min-h-screen bg-white">
            <nav className="border-b border-slate-200 bg-white">
                <div className="flex items-center justify-between h-16 px-6">
                    <div className="flex items-center">
                        <Link to="/dashboard" className="flex items-center gap-3">
                            <div className="h-8 w-8 rounded-lg bg-slate-900 flex items-center justify-center">
                                <span className="text-white font-bold text-sm">LS</span>
                            </div>
                            <span className="text-xl font-bold text-slate-900">LeadSync AI</span>
                        </Link>
                        <div className="ml-12 flex items-center gap-1">
                            {navItems.map((item) => {
                                const Icon = item.icon;
                                const isActive = location.pathname === item.path;
                                return (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        data-testid={`nav-${item.label.toLowerCase()}`}
                                        className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm transition-all ${isActive
                                                ? 'bg-slate-900 text-white'
                                                : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                                            }`}
                                    >
                                        <Icon className="h-4 w-4" />
                                        {item.label}
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                    <NotificationBell />
                </div>
            </nav>
            <main>
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;
